import * as Yup from 'yup';
import { Dto } from "../../../parts/crud/dto";




export class tenantDto extends Dto {
  constructor() {
    super();
    this.data.initialValues = {

      group_key: '',
      group_name: '',
      db_instance: '',
    };
    this.data.validationSchema = Yup.object({
      group_key: Yup.string().required('Il campo chiave è obbligatorio'),
      group_name: Yup.string().required('Il campo nome è obbligatorio'),
      db_instance: Yup.string().required('Il campo Db Host è obbligatorio')
    });
  }
}